import { defineMessages } from 'react-intl-next';

export const messages = defineMessages({
	ai_content_disclaimer: {
		id: 'search_ai.ai_content_disclaimer',
		defaultMessage: 'Uses AI. Verify results.',
		description: 'Text for the AI content disclaimer',
	},
	ai_debugger_icon_label: {
		id: 'search_ai.ai_debugger_icon_label',
		defaultMessage: 'Debugger',
		description: 'Label for debugger icon',
	},
	ai_debugger_modal_title: {
		id: 'search_ai.ai_debugger_modal_title',
		defaultMessage: 'SAIN Debugging Panel',
		description: 'Title for debugging modal',
	},
	ai_debugger_modal_original_query_subheading: {
		id: 'search_ai.ai_debugger_modal_original_query_subheading',
		defaultMessage: 'Original Query',
		description: 'Subheading for original query',
	},
	ai_debugger_modal_transformed_query_subheading: {
		id: 'search_ai.ai_debugger_modal_transformed_query_subheading',
		defaultMessage: 'Transformed Query',
		description: 'Subheading for transformed query',
	},
	ai_debugger_modal_detected_intent_subheading: {
		id: 'search_ai.ai_debugger_modal_detected_intent_subheading',
		defaultMessage: 'Detected Intent',
		description: 'Subheading for detected intent',
	},
	ai_debugger_modal_trace_id_subheading: {
		id: 'search_ai.ai_debugger_modal_trace_id_subheading',
		defaultMessage: 'Trace ID',
		description: 'Subheading for trace ID',
	},
	ai_debugger_modal_model_subheading: {
		id: 'search_ai.ai_debugger_modal_model_subheading',
		defaultMessage: 'Answer Generation Model',
		description: 'Subheading for model',
	},
	ai_debugger_modal_sources_subheading: {
		id: 'search_ai.ai_debugger_modal_sources_subheading',
		defaultMessage: 'Sources',
		description: 'Subheading for sources',
	},
	ai_debugger_modal_cached_answer_subheading: {
		id: 'search_ai.ai_debugger_modal_cached_answer_subheading',
		defaultMessage: 'Cached answer',
		description: 'Subheading for cached answer',
	},
	ai_debugger_modal_copy_button_text: {
		id: 'search_ai.ai_debugger_modal_copy_button_text',
		defaultMessage: 'Copy JSON',
		description: 'Text for copy button',
	},
	ai_debugger_modal_copy_button_copied_text: {
		id: 'search_ai.ai_debugger_modal_copy_button_copied_text',
		defaultMessage: 'JSON Copied',
		description: 'Text for copy button after JSON is copied',
	},
	ai_debugger_modal_tab_request_overview: {
		id: 'search_ai.ai_debugger_modal_tab_request_overview',
		defaultMessage: 'Request Overview',
		description: 'Label for request overview tab',
	},
	ai_debugger_modal_tab_plugin_invocations: {
		id: 'search_ai.ai_debugger_modal_tab_plugin_invocations',
		defaultMessage: 'Plugin Invocations',
		description: 'Label for plugin invocations tab',
	},
	ai_debugger_modal_tab_sources_used: {
		id: 'search_ai.ai_debugger_modal_tab_sources_used',
		defaultMessage: 'Sources Used',
		description: 'Label for sources used tab',
	},
	ai_debugger_modal_tab_raw_json: {
		id: 'search_ai.ai_debugger_modal_tab_raw_json',
		defaultMessage: 'Raw JSON',
		description: 'Label for raw JSON tab',
	},
	ai_debugger_modal_copy_trace_id_label: {
		id: 'search_ai.ai_debugger_modal_copy_trace_id_label',
		defaultMessage: 'Copy Trace ID',
		description: 'Label for copy Trace ID button',
	},
	ai_debugger_modal_trace_id_copied_text: {
		id: 'search_ai.ai_debugger_modal_trace_id_copied_text',
		defaultMessage: 'Trace ID copied',
		description: 'Text for Trace ID copied',
	},
	ai_debugger_modal_expand_label: {
		id: 'search_ai.ai_debugger_modal_expand_label',
		defaultMessage: 'Expand',
		description: 'Label for expand button',
	},
	ai_debugger_modal_collapse_label: {
		id: 'search_ai.ai_debugger_modal_collapse_label',
		defaultMessage: 'Collapse',
		description: 'Label for collapse button',
	},
	ai_debugger_modal_success_label: {
		id: 'search_ai.ai_debugger_modal_success_label',
		defaultMessage: 'Success',
		description: 'Label for success status',
	},
	ai_debugger_modal_failed_label: {
		id: 'search_ai.ai_debugger_modal_failed_label',
		defaultMessage: 'Failed',
		description: 'Label for failed status',
	},
	ai_debugger_modal_search_results_heading: {
		id: 'search_ai.ai_debugger_modal_search_results_heading',
		defaultMessage: 'Search Results ({count})',
		description: 'Heading for search results section with count',
	},
	ai_debugger_modal_ranked_documents_heading: {
		id: 'search_ai.ai_debugger_modal_ranked_documents_heading',
		defaultMessage: 'Ranked Documents ({count})',
		description: 'Heading for ranked documents section with count',
	},
	ai_debugger_modal_tab_minions_invoked: {
		id: 'search_ai.ai_debugger_modal_tab_minions_invoked',
		defaultMessage: 'Minions Invoked',
		description: 'Label for minions invoked tab',
	},
	ai_debugger_modal_no_plugins_invoked: {
		id: 'search_ai.ai_debugger_modal_no_plugins_invoked',
		defaultMessage: 'No plugins invoked.',
		description: 'Text shown when no plugins were invoked',
	},
	ai_debugger_modal_no_sources_used: {
		id: 'search_ai.ai_debugger_modal_no_sources_used',
		defaultMessage: 'No sources used.',
		description: 'Text shown when no sources were used',
	},
	ai_debugger_modal_teamwork_unnamed_team: {
		id: 'search_ai.ai_debugger_modal_teamwork_unnamed_team',
		defaultMessage: 'Unnamed Team',
		description: 'Fallback name for a team without a name',
	},
	ai_debugger_modal_teamwork_members_count: {
		id: 'search_ai.ai_debugger_modal_teamwork_members_count',
		defaultMessage: 'Members: {count}',
		description: 'Label for team members count',
	},
	ai_debugger_modal_teamwork_state: {
		id: 'search_ai.ai_debugger_modal_teamwork_state',
		defaultMessage: 'State: {state}',
		description: 'Label for team state',
	},
	ai_debugger_modal_teamwork_creator: {
		id: 'search_ai.ai_debugger_modal_teamwork_creator',
		defaultMessage: 'Creator: {creator}',
		description: 'Label for team creator',
	},
	ai_debugger_modal_teamwork_show_count: {
		id: 'search_ai.ai_debugger_modal_teamwork_show_count',
		defaultMessage: 'Show {count} {count, plural, one {member} other {members}}',
		description: 'Text for showing member count',
	},
	ai_debugger_modal_teamwork_hide_count: {
		id: 'search_ai.ai_debugger_modal_teamwork_hide_count',
		defaultMessage: 'Hide {count} {count, plural, one {member} other {members}}',
		description: 'Text for hiding member count',
	},
	ai_debugger_modal_author_label: {
		id: 'search_ai.ai_debugger_modal_author_label',
		defaultMessage: 'Author: {author}',
		description: 'Label for author field',
	},
	ai_debugger_modal_teamwork_document_updated: {
		id: 'search_ai.ai_debugger_modal_teamwork_document_updated',
		defaultMessage: 'Updated: {date}',
		description: 'Label for document updated date',
	},
	ai_debugger_modal_people_account_id: {
		id: 'search_ai.ai_debugger_modal_people_account_id',
		defaultMessage: 'Account ID: {accountId}',
		description: 'Label for people account ID',
	},
	ai_debugger_modal_people_email_label: {
		id: 'search_ai.ai_debugger_modal_people_email_label',
		defaultMessage: 'Email',
		description: 'Label for people email field',
	},
	ai_debugger_modal_people_location_label: {
		id: 'search_ai.ai_debugger_modal_people_location_label',
		defaultMessage: 'Location',
		description: 'Label for people location field',
	},
	ai_debugger_modal_people_department_label: {
		id: 'search_ai.ai_debugger_modal_people_department_label',
		defaultMessage: 'Department',
		description: 'Label for people department field',
	},
	ai_debugger_modal_people_organization_label: {
		id: 'search_ai.ai_debugger_modal_people_organization_label',
		defaultMessage: 'Organization',
		description: 'Label for people organization field',
	},
	ai_debugger_modal_people_timezone_label: {
		id: 'search_ai.ai_debugger_modal_people_timezone_label',
		defaultMessage: 'Timezone',
		description: 'Label for people timezone field',
	},
	ai_debugger_modal_people_locale_label: {
		id: 'search_ai.ai_debugger_modal_people_locale_label',
		defaultMessage: 'Locale',
		description: 'Label for people locale field',
	},
	ai_debugger_modal_page_search_space: {
		id: 'search_ai.ai_debugger_modal_page_search_space',
		defaultMessage: 'Space: {space}',
		description: 'Label for page search space',
	},
	ai_debugger_modal_page_search_count: {
		id: 'search_ai.ai_debugger_modal_page_search_count',
		defaultMessage: '{count} {count, plural, one {page} other {pages}} found',
		description: 'Count of pages found in page search',
	},
	ai_debugger_modal_function_results_count: {
		id: 'search_ai.ai_debugger_modal_function_results_count',
		defaultMessage: 'Function Results ({count})',
		description: 'Label for function results with count',
	},
});
